export const movies = [
  {
    id: "shawshank",
    title: "肖申克的救赎",
    year: 1994,
    region: "美国",
    score: 9.6,
    votes: "296万",
    duration: "142分钟",
    director: "弗兰克·德拉邦特",
    cast: "蒂姆·罗宾斯 / 摩根·弗里曼",
    category: "类型片",
    tags: ["剧情", "经典", "越狱"],
    rank: 1,
    doubanPick: true,
    summary:
      "银行家安迪被误判入狱，在肖申克监狱里用近二十年的时间守住希望与尊严，也让身边人重新理解自由的含义。",
    img: "https://readdy.ai/api/search-image?query=moody%20cinematic%20illustration%20of%20a%20lone%20silhouette%20figure%20in%20warm%20amber%20light%20with%20deep%20shadows%2C%20film%20grain%20texture%2C%20hopeful%20quiet%20atmosphere%2C%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p01&orientation=portrait",
  },
  {
    id: "farewell",
    title: "霸王别姬",
    year: 1993,
    region: "中国大陆 / 香港",
    score: 9.5,
    votes: "213万",
    duration: "171分钟",
    director: "陈凯歌",
    cast: "张国荣 / 张丰毅 / 巩俐",
    category: "类型片",
    tags: ["剧情", "戏曲", "时代"],
    rank: 2,
    doubanPick: true,
    summary:
      "两位京剧伶人跨越数十年的人生起落，把舞台上的悲欢离合与时代的动荡交织在一起。",
    img: "https://readdy.ai/api/search-image?query=stylized%20cinematic%20illustration%20of%20traditional%20chinese%20opera%20stage%20with%20flowing%20crimson%20silk%20and%20warm%20lantern%20glow%2C%20film%20grain%2C%20elegant%20art%20poster%20style&width=600&height=900&seq=qj-p02&orientation=portrait",
  },
  {
    id: "gump",
    title: "阿甘正传",
    year: 1994,
    region: "美国",
    score: 9.4,
    votes: "209万",
    duration: "142分钟",
    director: "罗伯特·泽米吉斯",
    cast: "汤姆·汉克斯 / 罗宾·怀特",
    category: "类型片",
    tags: ["剧情", "励志", "美国梦"],
    rank: 3,
    doubanPick: true,
    summary:
      "智商不高却心地纯粹的阿甘，一路奔跑着穿过美国几十年的社会变迁，也一路守着自己的信念。",
    img: "https://readdy.ai/api/search-image?query=stylized%20cinematic%20illustration%20of%20a%20winding%20road%20through%20golden%20fields%20under%20a%20soft%20sky%2C%20warm%20nostalgic%20tones%2C%20film%20grain%2C%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p03&orientation=portrait",
  },
  {
    id: "spirited",
    title: "千与千寻",
    year: 2001,
    region: "日本",
    score: 9.3,
    votes: "224万",
    duration: "125分钟",
    director: "宫崎骏",
    cast: "柊瑠美 / 入野自由",
    category: "类型片",
    tags: ["动画", "奇幻", "成长"],
    rank: 4,
    doubanPick: true,
    summary:
      "少女千寻误入神灵的世界，在汤屋打工求生，一点点找回名字、勇气与回家的路。",
    img: "https://readdy.ai/api/search-image?query=whimsical%20cinematic%20illustration%20of%20a%20lantern%20lit%20mystical%20street%20at%20dusk%20with%20warm%20amber%20glow%2C%20film%20grain%2C%20dreamy%20art%20poster%20style&width=600&height=900&seq=qj-p04&orientation=portrait",
  },
  {
    id: "godfather",
    title: "教父",
    year: 1972,
    region: "美国",
    score: 9.2,
    votes: "176万",
    duration: "175分钟",
    director: "弗朗西斯·福特·科波拉",
    cast: "马龙·白兰度 / 阿尔·帕西诺",
    category: "类型片",
    tags: ["剧情", "犯罪", "家族"],
    rank: 5,
    doubanPick: true,
    summary:
      "一个意大利裔家族的权力交接，在忠诚、亲情与利益的层层博弈中，写尽黑帮世界的秩序与代价。",
    img: "https://readdy.ai/api/search-image?query=moody%20cinematic%20illustration%20of%20a%20dimly%20lit%20vintage%20study%20with%20deep%20amber%20lamp%20light%20and%20long%20shadows%2C%20film%20grain%2C%20classic%20noir%20art%20poster%20style&width=600&height=900&seq=qj-p05&orientation=portrait",
  },
  {
    id: "leon",
    title: "这个杀手不太冷",
    year: 1994,
    region: "法国 / 美国",
    score: 9.2,
    votes: "223万",
    duration: "110分钟",
    director: "吕克·贝松",
    cast: "让·雷诺 / 娜塔莉·波特曼",
    category: "动作片",
    tags: ["动作", "剧情", "温情"],
    rank: 6,
    doubanPick: true,
    summary:
      "孤独的职业杀手与失去家人的少女相遇，在危险的都市夹缝里，两个陌生人组成了一段不寻常的依靠。",
    img: "https://readdy.ai/api/search-image?query=stylized%20cinematic%20illustration%20of%20a%20city%20rooftop%20at%20golden%20hour%20with%20warm%20amber%20and%20deep%20red%20tones%2C%20film%20grain%2C%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p06&orientation=portrait",
  },
  {
    id: "inception",
    title: "盗梦空间",
    year: 2010,
    region: "美国 / 英国",
    score: 9.1,
    votes: "198万",
    duration: "148分钟",
    director: "克里斯托弗·诺兰",
    cast: "莱昂纳多·迪卡普里奥 / 约瑟夫·高登-莱维特",
    category: "动作片",
    tags: ["科幻", "动作", "悬疑"],
    rank: 7,
    doubanPick: true,
    summary:
      "一支潜入梦境的团队要在层层嵌套的意识空间里完成一次植入任务，越往下走，现实与幻觉越发难分。",
    img: "https://readdy.ai/api/search-image?query=surreal%20cinematic%20illustration%20of%20a%20folded%20futuristic%20cityscape%20in%20warm%20amber%20and%20smoky%20tones%2C%20film%20grain%2C%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p07&orientation=portrait",
  },
  {
    id: "titanic",
    title: "泰坦尼克号",
    year: 1997,
    region: "美国",
    score: 9.0,
    votes: "187万",
    duration: "194分钟",
    director: "詹姆斯·卡梅隆",
    cast: "莱昂纳多·迪卡普里奥 / 凯特·温丝莱特",
    category: "爱情片",
    tags: ["爱情", "灾难", "史诗"],
    rank: 8,
    doubanPick: true,
    summary:
      "不同阶层的两个年轻人在这艘巨轮上相遇相爱，短暂的航程被一场海难永久定格。",
    img: "https://readdy.ai/api/search-image?query=romantic%20cinematic%20illustration%20of%20a%20grand%20ocean%20liner%20at%20warm%20sunset%20with%20golden%20and%20rose%20tones%20over%20a%20calm%20sea%2C%20film%20grain%2C%20elegant%20art%20poster%20style&width=600&height=900&seq=qj-p08&orientation=portrait",
  },
  {
    id: "infernal",
    title: "无间道",
    year: 2002,
    region: "香港",
    score: 9.0,
    votes: "135万",
    duration: "101分钟",
    director: "刘伟强 / 麦兆辉",
    cast: "梁朝伟 / 刘德华",
    category: "动作片",
    tags: ["犯罪", "悬疑", "警匪"],
    rank: 9,
    doubanPick: true,
    summary:
      "埋伏在警队里的黑帮卧底与潜入黑帮的警员，在天台上展开一场关于身份与选择的角力。",
    img: "https://readdy.ai/api/search-image?query=moody%20cinematic%20illustration%20of%20a%20rain%20soaked%20neon%20city%20alley%20at%20night%20with%20warm%20amber%20and%20red%20glow%2C%20film%20grain%2C%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p09&orientation=portrait",
  },
  {
    id: "flipped",
    title: "怦然心动",
    year: 2010,
    region: "美国",
    score: 9.1,
    votes: "168万",
    duration: "90分钟",
    director: "罗伯·莱纳",
    cast: "玛德琳·卡罗尔 / 卡兰·麦克奥利菲",
    category: "爱情片",
    tags: ["爱情", "成长", "青春"],
    rank: 10,
    doubanPick: true,
    summary:
      "一对邻家少年少女从彼此别扭到互相理解，在一棵梧桐树的见证下，讲完了一段干净明亮的初恋。",
    img: "https://readdy.ai/api/search-image?query=bright%20cinematic%20illustration%20of%20a%20suburban%20street%20with%20tall%20trees%20bathed%20in%20warm%20golden%20light%2C%20film%20grain%2C%20gentle%20art%20poster%20style&width=600&height=900&seq=qj-p10&orientation=portrait",
  },
  {
    id: "bettersun",
    title: "阳光灿烂的日子",
    year: 1994,
    region: "中国大陆",
    score: 8.8,
    votes: "63万",
    duration: "134分钟",
    director: "姜文",
    cast: "夏雨 / 宁静",
    category: "类型片",
    tags: ["剧情", "青春", "年代"],
    rank: null,
    doubanPick: false,
    summary:
      "上世纪七十年代的夏天，一群少年在胡同与操场上挥霍着无所事事的时光，记忆被阳光晒得发亮又失真。",
    img: "https://readdy.ai/api/search-image?query=warm%20nostalgic%20cinematic%20illustration%20of%20sunlit%20old%20city%20alleyway%20in%20golden%20haze%2C%20film%20grain%2C%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p11&orientation=portrait",
  },
  {
    id: "tigers",
    title: "卧虎藏龙",
    year: 2000,
    region: "中国大陆 / 美国",
    score: 8.5,
    votes: "58万",
    duration: "120分钟",
    director: "李安",
    cast: "周润发 / 杨紫琼 / 章子怡",
    category: "动作片",
    tags: ["武侠", "动作", "剧情"],
    rank: null,
    doubanPick: false,
    summary:
      "一把青冥剑牵出江湖恩怨，在竹林、屋顶与沙漠之间，武打与克制的情感相互缠绕。",
    img: "https://readdy.ai/api/search-image?query=elegant%20cinematic%20illustration%20of%20a%20misty%20bamboo%20forest%20with%20a%20flowing%20robed%20silhouette%2C%20warm%20green%20and%20gold%20tones%2C%20film%20grain%2C%20art%20poster%20style&width=600&height=900&seq=qj-p12&orientation=portrait",
  },
  {
    id: "dayswild",
    title: "花样年华",
    year: 2000,
    region: "香港",
    score: 8.7,
    votes: "72万",
    duration: "98分钟",
    director: "王家卫",
    cast: "梁朝伟 / 张曼玉",
    category: "爱情片",
    tags: ["爱情", "文艺", "年代"],
    rank: null,
    doubanPick: false,
    summary:
      "同住一层楼的两个人，在发现伴侣的秘密后彼此靠近，又把所有情意收进走廊、旗袍和夜色里。",
    img: "https://readdy.ai/api/search-image?query=nostalgic%20cinematic%20illustration%20of%20a%20narrow%20vintage%20hallway%20with%20warm%20amber%20light%20and%20flowing%20fabric%2C%20film%20grain%2C%20elegant%20art%20poster%20style&width=600&height=900&seq=qj-p13&orientation=portrait",
  },
  {
    id: "jokerwest",
    title: "大话西游之大圣娶亲",
    year: 1995,
    region: "香港",
    score: 8.9,
    votes: "128万",
    duration: "95分钟",
    director: "刘镇伟",
    cast: "周星驰 / 朱茵",
    category: "爱情片",
    tags: ["爱情", "喜剧", "奇幻"],
    rank: null,
    doubanPick: false,
    summary:
      "一场用笑声包裹的取经旧梦，猴子与仙子在错位的时空里相爱又错过，留下了那句被反复引用的告白。",
    img: "https://readdy.ai/api/search-image?query=whimsical%20cinematic%20illustration%20of%20a%20desert%20journey%20at%20golden%20dusk%20with%20lantern%20glow%20and%20warm%20amber%20tones%2C%20film%20grain%2C%20art%20poster%20style&width=600&height=900&seq=qj-p14&orientation=portrait",
  },
  {
    id: "loveletter",
    title: "情书",
    year: 1995,
    region: "日本",
    score: 8.9,
    votes: "105万",
    duration: "117分钟",
    director: "岩井俊二",
    cast: "中山美穗 / 柏原崇",
    category: "爱情片",
    tags: ["爱情", "文艺", "怀旧"],
    rank: null,
    doubanPick: false,
    summary:
      "一封寄往天国的信意外牵出少年时代的暗恋，雪国的小城让逝去的人与旧日心意重新浮现。",
    img: "https://readdy.ai/api/search-image?query=gentle%20cinematic%20illustration%20of%20a%20snowy%20small%20town%20under%20warm%20winter%20dusk%20light%20with%20soft%20rose%20and%20cream%20tones%2C%20film%20grain%2C%20art%20poster%20style&width=600&height=900&seq=qj-p15&orientation=portrait",
  },
  {
    id: "beforesunrise",
    title: "爱在黎明破晓前",
    year: 1995,
    region: "美国 / 奥地利",
    score: 8.8,
    votes: "68万",
    duration: "101分钟",
    director: "理查德·林克莱特",
    cast: "伊桑·霍克 / 朱莉·德尔佩",
    category: "爱情片",
    tags: ["爱情", "对白", "旅行"],
    rank: null,
    doubanPick: false,
    summary:
      "两个陌生人在火车上相识，用一整夜的漫步与长谈，把一天过成了一段难以忘怀的相遇。",
    img: "https://readdy.ai/api/search-image?query=warm%20cinematic%20illustration%20of%20a%20european%20riverside%20street%20at%20dawn%20with%20golden%20light%20and%20soft%20shadows%2C%20film%20grain%2C%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p16&orientation=portrait",
  },
  {
    id: "crazy-stone",
    title: "疯狂的石头",
    year: 2006,
    region: "中国大陆",
    score: 8.6,
    votes: "72万",
    duration: "98分钟",
    director: "宁浩",
    cast: "郭涛 / 刘桦 / 黄渤",
    category: "动作片",
    tags: ["喜剧", "犯罪", "多线"],
    rank: null,
    doubanPick: false,
    summary:
      "一块翡翠引来各路心怀鬼胎的人马，几组人马阴差阳错地卷进同一场闹剧，笑点与巧合密集碰撞。",
    img: "https://readdy.ai/api/search-image?query=playful%20cinematic%20illustration%20of%20a%20cluttered%20old%20city%20street%20with%20warm%20lanterns%20and%20lively%20comic%20energy%2C%20film%20grain%2C%20art%20poster%20style&width=600&height=900&seq=qj-p17&orientation=portrait",
  },
  {
    id: "heroes",
    title: "英雄本色",
    year: 1986,
    region: "香港",
    score: 8.8,
    votes: "67万",
    duration: "95分钟",
    director: "吴宇森",
    cast: "周润发 / 狄龙 / 张国荣",
    category: "动作片",
    tags: ["动作", "枪战", "兄弟"],
    rank: null,
    doubanPick: false,
    summary:
      "两个立场对立的旧友在江湖与警队之间周旋，枪火、风衣与情义构成了港式动作片的一段记忆。",
    img: "https://readdy.ai/api/search-image?query=stylized%20cinematic%20illustration%20of%20a%20lone%20figure%20in%20a%20dark%20warehouse%20with%20warm%20amber%20backlight%20and%20drifting%20smoke%2C%20film%20grain%2C%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p18&orientation=portrait",
  },
  {
    id: "shining",
    title: "闪灵",
    year: 1980,
    region: "美国 / 英国",
    score: 8.3,
    votes: "88万",
    duration: "146分钟",
    director: "斯坦利·库布里克",
    cast: "杰克·尼科尔森 / 谢莉·杜瓦尔",
    category: "恐怖片",
    tags: ["恐怖", "心理", "惊悚"],
    rank: null,
    doubanPick: false,
    summary:
      "一家三口在雪山旅馆过冬，空旷的走廊、对称的构图与逐渐失控的父亲，把封闭空间变成心理恐怖经典。",
    img: "https://readdy.ai/api/search-image?query=eerie%20cinematic%20illustration%20of%20an%20empty%20grand%20hotel%20corridor%20with%20cold%20light%20and%20one%20warm%20lamp%2C%20film%20grain%2C%20unsettling%20minimal%20art%20poster%20style&width=600&height=900&seq=qj-p19&orientation=portrait",
  },
  {
    id: "conjuring",
    title: "招魂",
    year: 2013,
    region: "美国",
    score: 7.9,
    votes: "34万",
    duration: "112分钟",
    director: "温子仁",
    cast: "维拉·法米加 / 帕特里克·威尔森",
    category: "恐怖片",
    tags: ["恐怖", "灵异", "惊悚"],
    rank: null,
    doubanPick: false,
    summary:
      "一对灵异调查夫妇介入一家人的农舍怪事，缓慢累积的压迫感让“看不见的东西”比怪物更吓人。",
    img: "https://readdy.ai/api/search-image?query=dark%20cinematic%20illustration%20of%20an%20old%20farmhouse%20at%20dusk%20with%20a%20faint%20warm%20window%20glow%20and%20moody%20shadows%2C%20film%20grain%2C%20horror%20art%20poster%20style&width=600&height=900&seq=qj-p20&orientation=portrait",
  },
  {
    id: "ring",
    title: "午夜凶铃",
    year: 1998,
    region: "日本",
    score: 7.4,
    votes: "21万",
    duration: "96分钟",
    director: "中田秀夫",
    cast: "松岛菜菜子 / 真田广之",
    category: "恐怖片",
    tags: ["恐怖", "悬疑", "日式"],
    rank: null,
    doubanPick: false,
    summary:
      "一盘相传带来诅咒的录像带，让记者在七天倒计时里追查真相，也把日式恐怖推向了更广的观众。",
    img: "https://readdy.ai/api/search-image?query=chilling%20cinematic%20illustration%20of%20a%20dark%20room%20with%20a%20glowing%20television%20and%20static%20haze%2C%20cold%20tones%20with%20faint%20amber%2C%20film%20grain%2C%20horror%20art%20poster%20style&width=600&height=900&seq=qj-p21&orientation=portrait",
  },
  {
    id: "hereditary",
    title: "遗传厄运",
    year: 2018,
    region: "美国",
    score: 7.3,
    votes: "27万",
    duration: "127分钟",
    director: "阿里·艾斯特",
    cast: "托妮·科莱特 / 加布里埃尔·伯恩",
    category: "恐怖片",
    tags: ["恐怖", "家庭", "心理"],
    rank: null,
    doubanPick: false,
    summary:
      "一个家庭在祖母离世后接连遭遇怪事，恐怖被安放在日常细节里，也潜藏在难以挣脱的血缘之中。",
    img: "https://readdy.ai/api/search-image?query=dreadful%20cinematic%20illustration%20of%20a%20shadowy%20wooden%20dollhouse%20room%20lit%20by%20a%20single%20warm%20bulb%2C%20film%20grain%2C%20ominous%20art%20poster%20style&width=600&height=900&seq=qj-p22&orientation=portrait",
  },
  {
    id: "alien",
    title: "异形",
    year: 1979,
    region: "美国 / 英国",
    score: 8.3,
    votes: "31万",
    duration: "117分钟",
    director: "雷德利·斯科特",
    cast: "西格妮·韦弗 / 汤姆·斯凯里特",
    category: "恐怖片",
    tags: ["科幻", "恐怖", "惊悚"],
    rank: null,
    doubanPick: false,
    summary:
      "一艘商船在深空收到求救信号，船员们带回的不明生物在密闭飞船里逐一亮相，科幻与恐怖就此合流。",
    img: "https://readdy.ai/api/search-image?query=dark%20cinematic%20illustration%20of%20a%20lone%20figure%20in%20a%20dim%20industrial%20spaceship%20corridor%20with%20warm%20amber%20emergency%20light%2C%20film%20grain%2C%20sci%20fi%20horror%20art%20poster%20style&width=600&height=900&seq=qj-p23&orientation=portrait",
  },
  {
    id: "incantation",
    title: "咒",
    year: 2022,
    region: "中国台湾",
    score: 7.2,
    votes: "18万",
    duration: "111分钟",
    director: "柯孟融",
    cast: "蔡亘晏 / 黄歆庭",
    category: "恐怖片",
    tags: ["恐怖", "伪纪录", "民俗"],
    rank: null,
    doubanPick: false,
    summary:
      "以伪纪录片的方式讲述一场与禁忌有关的探访，观众被拉进镜头语言里，和主角一起直面未知。",
    img: "https://readdy.ai/api/search-image?query=unsettling%20cinematic%20illustration%20of%20a%20dim%20rural%20shrine%20with%20flickering%20warm%20candles%20and%20heavy%20shadows%2C%20film%20grain%2C%20horror%20art%20poster%20style&width=600&height=900&seq=qj-p24&orientation=portrait",
  },
  {
    id: "lifeofpi",
    title: "少年派的奇幻漂流",
    year: 2012,
    region: "美国 / 中国台湾",
    score: 9.1,
    votes: "137万",
    duration: "127分钟",
    director: "李安",
    cast: "苏拉·沙玛 / 伊尔凡·可汗",
    category: "类型片",
    tags: ["剧情", "奇幻", "冒险"],
    rank: null,
    doubanPick: true,
    summary:
      "少年与一只孟加拉虎在同一条救生艇上漂泊，海上奇景与两个版本的结局，让故事留在观众心里反复回味。",
    img: "https://readdy.ai/api/search-image?query=dreamy%20cinematic%20illustration%20of%20a%20small%20boat%20on%20a%20glowing%20warm%20ocean%20under%20a%20starry%20sky%2C%20amber%20and%20deep%20tones%2C%20film%20grain%2C%20art%20poster%20style&width=600&height=900&seq=qj-p25&orientation=portrait",
  },
];

export const heroBanner =
  "https://readdy.ai/api/search-image?query=abstract%20cinematic%20background%20with%20warm%20amber%20and%20deep%20crimson%20light%20beams%20cutting%20through%20smoky%20darkness%2C%20projector%20glow%20and%20film%20reel%20atmosphere%2C%20film%20grain%2C%20dramatic%20wide%20composition&width=1920&height=1080&seq=qj-hero-bg&orientation=landscape";

export const spotlightBanners = {
  action:
    "https://readdy.ai/api/search-image?query=dynamic%20cinematic%20wide%20illustration%20of%20a%20night%20city%20chase%20with%20warm%20amber%20and%20red%20streaks%20of%20light%2C%20film%20grain%2C%20energetic%20composition&width=1600&height=900&seq=qj-banner-action&orientation=landscape",
  romance:
    "https://readdy.ai/api/search-image?query=soft%20cinematic%20wide%20illustration%20of%20two%20silhouettes%20under%20warm%20golden%20dusk%20with%20gentle%20bokeh%20lights%2C%20film%20grain%2C%20romantic%20composition&width=1600&height=900&seq=qj-banner-romance&orientation=landscape",
  horror:
    "https://readdy.ai/api/search-image?query=dark%20cinematic%20wide%20illustration%20of%20a%20foggy%20forest%20with%20a%20faint%20lantern%20glow%20and%20deep%20shadows%2C%20film%20grain%2C%20eerie%20composition&width=1600&height=900&seq=qj-banner-horror&orientation=landscape",
};

export const spotlightEditors = {
  action: {
    title: "动作片",
    intro:
      "动作片专区把关注点放在场面调度与节奏上：从港式枪火到科幻动作，从近身搏斗到多线叙事，动作的“设计感”往往决定了它能不能被反复重看。",
    picks: ["infernal", "leon", "heroes"],
    note: "观看建议：动作片的爽感来自剪辑与镜头设计，遇到快速切换的段落不妨放慢再看一遍动作拆解。",
  },
  romance: {
    title: "爱情片",
    intro:
      "爱情片专区更看重情绪与留白：有的是史诗式的相遇，有的是走廊与雪夜里被克制的靠近，也有把告白讲成笑话的青春故事。",
    picks: ["titanic", "dayswild", "jokerwest"],
    note: "观看建议：爱情片适合在安静的时段独自观看，台词和沉默同样是重要线索。",
  },
  horror: {
    title: "恐怖片",
    intro:
      "恐怖片专区覆盖心理惊悚、灵异与伪纪录等方向：真正让人后背发凉的，常常不是怪物，而是被拉长的安静与日常细节的失序。",
    picks: ["shining", "conjuring", "incantation"],
    note: "观看提示：胆小者建议白天观看，注意音量，部分作品含有突发音效与惊吓镜头。",
  },
};

export const genreTabs = ["全部", "类型片", "动作片", "爱情片", "恐怖片"];

export const rankingNotes = [
  { label: "综合评分", value: "由编辑按叙事、表演、影像与重看价值综合折算，满分为 10 分。" },
  { label: "更新时间", value: "榜单随片单整理周期滚动更新，本期为示例版本，仅作找片参考。" },
  { label: "入选门槛", value: "同一影片仅收录一次，系列作品只取代表段落或单部代表作。" },
];

export const scoringCriteria = [
  {
    icon: "ri-quill-pen-line",
    title: "叙事完成度",
    desc: "故事结构是否完整、伏笔与回收是否自然，决定影片能否把观众留在座位上。",
  },
  {
    icon: "ri-user-star-line",
    title: "表演与角色",
    desc: "角色是否有说服力、演员能否撑起情绪转折，是高分片最容易被记住的部分。",
  },
  {
    icon: "ri-image-2-line",
    title: "影像与调度",
    desc: "构图、色彩、剪辑节奏与配乐共同构成影片的观感，也是类型片差异化的关键。",
  },
  {
    icon: "ri-repeat-2-line",
    title: "重看价值",
    desc: "值得二刷三刷的作品，往往藏着第一遍没注意到的细节，评分也会因此被拉高。",
  },
];

export const faqs = [
  {
    q: "九七电影院的排行榜是怎么排出来的？",
    a: "本期排行榜综合影片的叙事、表演、影像与重看价值，由编辑折算成 10 分制后排序。它是一份帮助找片的参考榜单，不是单一维度的票房或热度排名，因此会同时出现经典老片与近年的类型片。",
  },
  {
    q: "“豆瓣高分”在页面里代表什么？",
    a: "这里的豆瓣高分更接近一个入口标签，用来指代口碑长期靠前、被反复讨论的作品。页面展示的分数为站内综合评分，用于内部排序与对比，浏览时建议结合影片简介与类型来判断是否符合自己的口味。",
  },
  {
    q: "类型片和动作片、爱情片、恐怖片是什么关系？",
    a: "类型片是更宽的口径，指按题材与叙事惯例划分的一类作品；动作片、爱情片、恐怖片则是其中的具体方向。你可以先在类型片浏览区按分类或关键词筛选，再到对应专区看更集中的推荐。",
  },
  {
    q: "页面上的标签筛选和搜索有什么限制？",
    a: "标签切换与关键词筛选都只作用于本页已经收录的影片，不会联网请求片库，也不会保存你的输入。刷新页面后筛选状态会重置，属于纯浏览体验。",
  },
  {
    q: "我想按自己的口味找片，应该从哪里开始？",
    a: "如果你在意口碑，可以先看排行榜与豆瓣高分精选；如果你有明确偏好，直接用类型片浏览器切到动作片、爱情片或恐怖片，再用关键词缩小范围，通常几步就能找到合适的片单。",
  },
];

export const siteStats = [
  { value: "24", label: "本期收录影片" },
  { value: "5", label: "浏览分类维度" },
  { value: "10", label: "排行榜入选席位" },
  { value: "每周", label: "片单整理节奏" },
];